var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 140,
    viewBox: "0 0 328 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 5",
    filter: "url(#filter0_f_1567_2238)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.5,
    cy: 66.2684,
    rx: 107.5,
    ry: 67.2889,
    fill: "#8870FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6",
    filter: "url(#filter1_f_1567_2238)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 270,
    cy: 57.75,
    rx: 57,
    ry: 47.25,
    fill: "#00E1FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1567_2238",
    x: 0,
    y: -181.021,
    width: 575,
    height: 494.578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_1567_2238"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1567_2238",
    x: 193,
    y: -9.5,
    width: 154,
    height: 134.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1567_2238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotBg);
export default __webpack_public_path__ + "static/media/bot-bg.bd1928a952f30f595e931184c592ce72.svg";
export { ForwardRef as ReactComponent };